(() => {
'use strict';
const normalize = value => String(value || '').toUpperCase().replace(/\s+/g, '');
const text = value => String(value || '').trim().replace(/\s+/g, ' ');
const VICE_TYPES = [
  'Grinding and inspection vice with quick adjustment',
  'Grinding and inspection vice with threaded spindle',
  'Sine Vices',
  'Specials',
  '2 Way Precision Vice',
  '3 Way Precision Vice'
];
function viceType(value) {
  const key=text(value).toLowerCase();
  if (key==='sine vice' || key==='sine vise' || key==='sine vises') return 'Sine Vices';
  if (key==='special') return 'Specials';
  return VICE_TYPES.find(type=>type.toLowerCase()===key) || '';
}
const queries = {
  vices: ['title:vice* OR title:vise* OR title:sine*'],
  angle: ['title:"angle plate" OR title:"angle plates" OR title:angleplate*'],
  vee: ['title:"vee block" OR title:"vee blocks" OR title:"v-block" OR title:"v block" OR title:veeblock* OR title:vblock*'],
  'granite-plates': ['title:granite'],
  'granite-tables': ['title:granite'],
  parallels: ['title:parallel*'],
  'straight-edges': ['title:"straight edge" OR title:"straight edges" OR title:straightedge*'],
  rules: ['title:rule*']
};
function belongs(title, family, known, skus = []) {
  if (/\b(?:calibration|calibrating|replacement|spare|accessories|accessory)\b/i.test(title)) return false;
  if (family === 'vices') return /\b(?:vices?|vises?|sine)\b/i.test(title);
  if (family === 'angle') return known || /\bangle[ -]?plates?\b/i.test(title);
  if (family === 'vee') return /\b(?:vee|v)[ -]?blocks?\b/i.test(title) && !/\bclamp\s+only\b|^clamps?\b|\bclamps?\s+for\b|\b(?:vee|v)[ -]?block\s+clamps?\b/i.test(title);
  if (family === 'granite-plates') return /\bgranite\b/i.test(title) && /\b(?:surface\s+)?(?:plates?|plaqtes?)\b/i.test(title) && !/\bstands?|support|table\b/i.test(title);
  if (family === 'granite-tables') return /\bgranite\b/i.test(title) && (/\btables?\b/i.test(title) || (/\bplates?\b/i.test(title) && /with\s+(?:a\s+)?stand/i.test(title))) && !/\b(?:support|comparator|indicator|measuring)\b/i.test(title) && !/\bstand\s+(?:only|for)\b/i.test(title);
  if (family === 'parallels') {
    if (/\b(?:optical|opt|micrometer|caliper|ruler|rule|clamp|vice|vise|indicator|comparator|roughness|thread|jaw|grip)\b|gauge\s+blocks?/i.test(title)) return false;
    return /\bparallels\b|\b(?:adjustable|steel|precision|machinist)\s+parallel\b|\bparallel\s+(?:sets?|pairs?|bars?|blocks?)\b|\bmagnetic\s+chuck\s+parallel\b/i.test(title) || skus.some(s=>['637-7972','637-7964'].includes(normalize(s)));
  }
  if (family === 'straight-edges') return /\bstraight[ -]?edges?\b/i.test(title);
  return /\b(?:rules?|rulers?)\b/i.test(title) && !/\b(?:combination|protractor|square|head|holder|stop|spare|replacement|caliper|micrometer)\b/i.test(title);
}
function dimensions(value) {
  const number = '(?:\\d+(?:[.,]\\d+)?(?:[- ]\\d+\\/\\d+)?|\\d+\\/\\d+)';
  const match = String(value).match(new RegExp('(' + number + '(?:\\s*(?:mm|["″])?\\s*[x×]\\s*' + number + '){1,3}\\s*(?:mm|inch(?:es)?|["″])?)', 'i'));
  return match ? text(match[1]).replace(/\s*[x×]\s*/gi, ' × ') : '';
}
function specs(record, family, master) {
  const d = record.dataset, title = text(d.title), details = title + ' ' + text(d.description) + ' ' + text(d.technical);
  const r = {id:d.id,title,brand:text(d.vendor),sku:'',price:Number(d.price),template:record};
  let skus = [];
  try { skus = JSON.parse(d.skus || '[]'); } catch (_) {}
  r.sku = skus.filter(Boolean).join(' / ');
  const known = skus.map(s => master.get(normalize(s))).find(Boolean);
  if (!belongs(title, family, Boolean(known), skus)) return null;
  r.brand = known?.brand || r.brand;
  if (family === 'vices') r.brand=text(d.manufacturer) || r.brand;
  r.size = known?.size || text(d.size) || dimensions(title);
  if (!r.size && family === 'rules') {
    const length = title.match(/\b\d+(?:[.,]\d+)?\s*(?:mm|cm|metres?|meters?|inch(?:es)?|["″])/i);
    if (length) r.size = length[0];
  }
  if (!r.size) r.size = dimensions(details);
  if (family === 'vices' && !r.size) {
    const size=title.match(/\b\d+(?:[.,]\d+)?\s*(?:mm|inch(?:es)?|["″”])/i);
    r.size=size ? text(size[0]) : '';
  }
  const grade = details.match(/\bgrade\s*[:=]?\s*(00|0|1|2|[AB])\b/i);
  r.grade = known?.grade || text(d.grade) || (grade ? grade[1].toUpperCase() : '');
  const material = details.match(/\b(?:granite|cast[ -]?iron|stainless[ -]?steel|steel|ceramic|aluminium|aluminum)\b/i);
  r.material = text(d.material) || (material ? material[0].replace(/-/g, ' ').replace(/\b\w/g, m=>m.toUpperCase()) : '');
  if (family === 'vices') r.material=text(d.blockMaterial) || r.material;
  if (known) r.type = known.type;
  else if (family === 'angle') r.type = /swivel|tilting|adjustable/i.test(title) ? 'Swivel' : /open[ -]?(?:ed)?[ -]?end/i.test(title) ? 'Open Ended' : /webbed/i.test(title) ? 'Webbed' : /solid/i.test(title) ? 'Solid' : '';
  else if (family === 'vee') r.type = /magnetic/i.test(title) ? 'Magnetic' : /double/i.test(title) ? 'Double Vee' : /heavy[ -]?duty/i.test(title) ? 'Heavy Duty' : 'Standard';
  else if (family === 'parallels') r.type = /adjustable/i.test(title) ? 'Adjustable' : /sets?\b/i.test(title) ? 'Sets' : /pairs?/i.test(title) ? 'Pairs' : 'Individual';
  else if (family === 'straight-edges') r.type = /knife/i.test(title) ? 'Knife Edge' : /graduated/i.test(title) ? 'Graduated' : 'Standard';
  else if (family === 'rules') r.type = /flexible/i.test(title) ? 'Flexible' : /rigid|wide/i.test(title) ? 'Rigid' : 'Standard';
  else r.type = family === 'granite-tables' ? (/with\s+(?:a\s+)?stand/i.test(title) ? 'With Stand' : '') : '';
  if (family === 'vices') r.type=viceType(d.viceType);

  const unitText = r.size + ' ' + title;
  r.units = /mm|\bcm\b|metric/i.test(unitText) ? (/["″]|\binch|imperial/i.test(unitText) ? 'Inch/Metric' : 'Metric') : /["″]|\binch|imperial/i.test(unitText) ? 'Inch' : '';
  return r;
}
async function getText(url) {
  const controller = new AbortController(), timer = setTimeout(()=>controller.abort(), 45000);
  try { const response = await fetch(url, {credentials:'same-origin',signal:controller.signal}); if (!response.ok) throw Error('Product data unavailable'); return await response.text(); }
  finally { clearTimeout(timer); }
}
async function init(host) {
  const family = host.dataset.family;
  if (!queries[family] || host.dataset.initialized) return;
  host.dataset.initialized = 'true';
  const find = s => host.querySelector(s), status=find('[data-mqsw-status]'), retry=find('[data-mqsw-retry]'), filters=find('[data-mqsw-filters]'), grid=find('[data-mqsw-grid]'), count=find('[data-mqsw-count]'), pages=find('[data-mqsw-pages]'), sort=find('[data-mqsw-sort]');
  const tr=JSON.parse(host.dataset.translations || '{}');
  const t=(key,fallback)=>tr[key] || fallback;
  const title=host.querySelector('[data-family-link="'+family+'"] strong').textContent;
  find('[data-mqsw-heading]').textContent=title;
  const previewId=new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role==='main'?'':host.dataset.theme);
  let records=[], selected={}, page=1, running=false;
  const fields=family==='vices'?[['brand','Brand'],['type','Type'],['size','Size'],['material','Material'],['units','Units']]:family==='angle'?[['brand','Brand'],['type','Type'],['size','Size'],['grade','Grade']]:[['brand','Brand'],['type','Type'],['size','Size / Length'],['material','Material'],['grade','Grade'],['units','Units']];
  const label=k=>k==='size' && family==='vices' ? t('vices_size','Size') : k==='size' && family==='angle' ? t('angle_size','Size') : t(k,k[0].toUpperCase()+k.slice(1));
  const matches=(r,skip)=>Object.entries(selected).every(([k,v])=>!v || k===skip || (r[k] || t('unspecified','Not specified'))===v);
  function render() {
    const focusKey=document.activeElement?.dataset.mqswFilter;
    filters.replaceChildren();
    for (const [key] of fields) {
      if (family!=='angle' && !(family==='vices' && key==='type') && !records.some(r=>r[key]) && !selected[key]) continue;
      const values=[...new Set(records.filter(r=>matches(r,key)).map(r=>r[key] || t('unspecified','Not specified')))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
      if (family==='vices' && key==='type') values.splice(0,values.length,...VICE_TYPES);
      const field=document.createElement('label');field.className='mqsm__field';field.textContent=label(key);
      const select=document.createElement('select');select.dataset.mqswFilter=key;select.add(new Option(t('all','All')+' '+label(key),''));
      if (selected[key] && !values.includes(selected[key])) values.push(selected[key]);
      for (const v of values) select.add(new Option(v,v));select.value=selected[key] || '';
      select.addEventListener('change',()=>{selected[key]=select.value;page=1;render();});field.append(select);filters.append(field);
    }
    const clear=document.createElement('button');clear.type='button';clear.className='mqsm__reset';clear.textContent=t('clear','Clear filters');clear.addEventListener('click',()=>{selected={};page=1;render();});filters.append(clear);
    if (focusKey) filters.querySelector('[data-mqsw-filter="'+focusKey+'"]')?.focus();
    const results=records.filter(r=>matches(r));
    const order=sort.value, number=r=>{
      const value=String(r.size||''), mixed=value.match(/^(\d+)[ -](\d+)\/(\d+)/), fraction=value.match(/^(\d+)\/(\d+)/), decimal=value.match(/\d+(?:[.,]\d+)?/);
      const n=mixed?Number(mixed[1])+Number(mixed[2])/Number(mixed[3]):fraction?Number(fraction[1])/Number(fraction[2]):decimal?Number(decimal[0].replace(',','.')):Infinity;
      return n*(/["″]|\binch/i.test(value) && !/mm/i.test(value)?25.4:1);
    };
    results.sort((a,b)=>{
      if(order==='price' || order==='price-desc') return (a.price-b.price)*(order==='price-desc'?-1:1);
      if(order==='brand' || order==='sku') return a[order].localeCompare(b[order],undefined,{numeric:true});
      const x=number(a),y=number(b);return (x===y?a.title.localeCompare(b.title):x-y)*(order==='size-desc'?-1:1);
    });
    const max=Math.max(1,Math.ceil(results.length/24));page=Math.min(page,max);
    count.textContent=results.length+' '+t('products','products');grid.replaceChildren();
    for(const r of results.slice((page-1)*24,page*24)) {
      const card=r.template.content.cloneNode(true),body=card.querySelector('.mqsm-card__body'), spec=document.createElement('p');spec.className='mqs-workholding__spec';
      spec.textContent=fields.filter(([k])=>k!=='brand' && r[k]).map(([k])=>label(k)+': '+r[k]).join(' · ');
      if(body) {const sku=body.querySelector('.mqsm-card__sku');if(sku)sku.textContent='SKU: '+r.sku;body.querySelector('.mqsm-card__title')?.after(spec);}
      grid.append(card);
    }
    if(!results.length) {const empty=document.createElement('p');empty.textContent=t('empty','No matching products. Clear the filters to see all products.');grid.append(empty);}
    pages.replaceChildren();
    if(max>1) {
      const prev=document.createElement('button'),next=document.createElement('button'),info=document.createElement('span');prev.type=next.type='button';prev.textContent=t('previous','Previous');next.textContent=t('next','Next');prev.disabled=page===1;next.disabled=page===max;info.textContent=page+' / '+max;
      prev.addEventListener('click',()=>{page--;render();grid.scrollIntoView({block:'start'});});next.addEventListener('click',()=>{page++;render();grid.scrollIntoView({block:'start'});});pages.append(prev,info,next);
    }
  }
  async function load() {
    if(running)return;running=true;retry.hidden=true;status.textContent=t('loading','Loading products…');
    try {
      let master=new Map();
      if(family==='angle') {const response=await fetch(host.dataset.master,{credentials:'same-origin'});if(!response.ok)throw Error('Specifications unavailable');master=new Map((await response.json()).map(r=>[normalize(r.sku),r]));}
      const found=new Map();
      async function feed(query,p=1) {
        const url=new URL(host.dataset.search,location.origin);url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('view','mqs-workholding-data');url.searchParams.set('page',String(p));url.searchParams.set('options[prefix]','none');if(previewId)url.searchParams.set('preview_theme_id',previewId);
        const doc=new DOMParser().parseFromString(await getText(url),'text/html'),source=doc.querySelector('[data-mqs-workholding-feed]');if(!source)throw Error('Product feed unavailable');
        for(const item of source.querySelectorAll('[data-mqs-workholding-record]')) {const r=specs(item,family,master);if(r)found.set(r.id,r);}
        return Number(source.dataset.pages)||1;
      }
      const sourceQueries=[...queries[family]];
      if(family==='angle') {const skus=[...master.keys()];for(let i=0;i<skus.length;i+=12)sourceQueries.push(skus.slice(i,i+12).map(s=>'"'+s+'"').join(' OR '));}
      for(const q of sourceQueries) {
        const total=await feed(q);if(total>40)throw Error('Too many product pages');
        for(let first=2;first<=total;first+=3)await Promise.all(Array.from({length:Math.min(3,total-first+1)},(_,i)=>feed(q,first+i)));
      }
      records=[...found.values()];filters.hidden=false;find('[data-mqsw-toolbar]').hidden=false;status.textContent='';render();
    } catch (_) {status.textContent=t('error','Products could not load. Please retry.');retry.hidden=false;}
    finally {running=false;}
  }
  sort.addEventListener('change',()=>{page=1;render();});retry.addEventListener('click',load);await load();
}
document.querySelectorAll('[data-mqs-workholding]').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mqs-workholding]').forEach(init));
})();
